import React from 'react';
import { Link } from 'react-router-dom';
import { usePlatform } from '../../context/PlatformContext';
import './Footer.css';

const Footer = () => {
  const { isMobileApp } = usePlatform();

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-links">
          <Link to="/about">About Us</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/cookies-policy">Cookie Policy</Link>
          <Link to="/terms">Terms and Conditions</Link>
          <Link to="/contact">Contact Us</Link>
          {!isMobileApp && <Link to="/super-admin/login" className="admin-link">Admin</Link>}
        </div>
        <div className="footer-copyright">
          &copy; {new Date().getFullYear()} WasteMapr.com. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
